import React from "react";
import { PropTypes } from 'prop-types';
import _ from 'lodash';
import moment from "moment";
import SuccessorInfo from "./SuccessorInfo";
import PhoneInfo from "./PhoneInfo";
import EmailInfo from "./EmailInfo";
import AddressInfo from "./AddressInfo";
import { PillButtonAdd } from "../../Step1Setup/styles";
import {
  PillButtonGreen,
  PillButtonGreenWrap,
  PillButtonAddSpaceAdd,
  PillButtonAddSpaceAddManual
} from "./Tabs/styles";
import { connect } from "react-redux";
import Popup from "../../Step1Setup/Components/Popup/Popup";
import { getAlert, mapContents } from "../../Step1Setup/Components/UtilFunctions";
import CharityBasicInfo from "./CharityBasicInfo";
import { PillButtonSelect } from "./LegacyAccordions/styles";
import { ShowLessWrapMargin, ImageWrap } from "./AccordionContent/styles";
import upArrow from "../../../../../assets/icons/short-arrow-t-green.svg";
import {
  showRemainingPercentage,
  shouldClose,
  setPercentage,
  setSuccessorValues,
  jsonTemp,
  fieldValues,
  validationHandler,
  getAccordionStatus,
  updateAccordionStatus,
  updateAccordionState,
  setCityFieldEdit
} from "../../actions";
import { ErrMargin, MarginWrapper } from "../styles";
import regexMap from "../../../../../utils/regexMap";
import { initiateTracking, recordError } from "../../../../../utils/commonUtil";
import { resetZipCode, resetAllZipFields } from "../../../../../CommonComponents/Zipcode/actions";
import { basicAlertContents } from '../../DefaultPropTypes';
import { CapsuleButton } from "../../../../../CommonComponents/Commons/commonComponents";
import { MarginWrapperBtn } from "./styles";

export class Form extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
      type: "",
      alertStatus: false,
      removePopupContentAppoint: {
        heading: "Remove successor",
        line1: "Are you sure you want to remove successor?",
        line2: "Do you want to continue?",
        continue: "continue",
        cancel: "No, take me back",
        type: "remove"
      },
      removePopupContentCreate: {
        heading: "Remove successor account",
        line1: "Are you sure you want to remove successor account?",
        line2: "Do you want to continue?",
        continue: "continue",
        cancel: "No, take me back",
        type: "remove"
      },
      removePopupContentCharity: {
        heading: "Remove charity",
        line1: "Are you sure you want to remove the charity?",
        line2: "Do you want to continue?",
        continue: "continue",
        cancel: "No, take me back",
        type: "remove"
      },
    };
  }

  closeModal = () => {
    this.setState({
      show: false
    });
  };

  changeValidationCheck = () => {
    this.props.validationHandler(false);
  };

  checkForData = ({firstname,lastname,dob} ,val) => {
    if(firstname && lastname && dob && val.firstName && val.lastName && val.dob){
      return true;
    }
    return false;
  }

  checkForAdvisor = ({firstname,lastname,dob} ,val) => {
    if(this.checkForData({firstname,lastname,dob} ,val) && (firstname.toLowerCase() === val.firstName.toLowerCase() && lastname.toLowerCase() === val.lastName.toLowerCase() && dob === moment(val.dob).format("MM/DD/YYYY"))){
      return true;
    } 
     return false;
  }

  handleSave = async successors => {
    
    let hasFieldValues = true;
    let arr = successors;
    let accordionState = [...this.props.accordionStates]; /** 0 - Not touched, 1 - Incomplete, 2 - Complete */
    let percentage;
    if (this.props.isStep2Edit) {
      percentage = this.props.tempData.tempJSON.legacyOptions[
        this.props.contentKey - 1
      ].percentage;
    } else {
      percentage = this.props.percentage;
    }
    if (percentage.length < 1) {
      let arr;
      if (this.props.isStep2Edit) {
        arr = this.props.tempData.tempJSON.legacyOptions;
      } else {
        arr = this.props.legacy.legacyOptions;
      }
      arr.filter(val => {
        if (val.optionId == this.props.contentKey) {
          if (val.percentage.length < 1) {
            return (val.percentageError = (
              <ErrMargin>Please enter percentage</ErrMargin>
            ));
          } else {
            return (val.percentageError = null);
          }
        }
      });
      if (this.props.isStep2Edit) {
        let tempData = this.props.tempData.tempJSON;
        tempData.legacyOptions = arr;
        this.props.jsonTemp({
          tempJSON: tempData,
          enableReset: true
        });
      } else {
        this.props.setPercentage({
          legacyOptions: {
            legacyOptions: arr
          }
        });
      }
    }

    let validationCounter = 0;
    let totalCharityPercentage = 0;
    let charityAllocFlag = true;
    let advisorMatchCounter = 0;
    
    let entireData = null;
    let advTab = null;
    let tabIndexError = [];
    if (this.props.isStep2Edit) {
      entireData = this.props.tempData.tempJSON.legacyOptions;
    } else {
      entireData = this.props.legacy.legacyOptions;
    }

    arr.forEach((val,currentIndex) => {
      if (this.props.contentKey == 4) {
        if (val.name == "") {
          val.charityNameError = (
            <ErrMargin>Please enter charity name</ErrMargin>
          );
        } else {
          val.charityNameError = null;
        }
        
        if(val.charityAllocPercent === ""){
          val.charityAllocPercentError = (
            <ErrMargin>
              Please enter % of charity
            </ErrMargin>
          );
        }else{
          totalCharityPercentage += parseInt(val.charityAllocPercent);
        }

        if(val.grantRecognition === ""){
          val.grantRecognitionError = (
            <ErrMargin>
              Grant recognition required
            </ErrMargin>
          );
        }
        if(!val.grantPurpose){
          val.otherGrantPurposeTextError = (
            <ErrMargin>
              Grant purpose required
            </ErrMargin>
          );
        }

        if(val.otherGrantPurposeText === "" && val.grantPurpose === 'OTHER'){
          val.otherGrantPurposeTextError = (
            <ErrMargin>
              Grant purpose required
            </ErrMargin>
          );
        }
        val.phoneError = null;

        if (!val.address.line1) {
          val.address.line1Error = <ErrMargin>Please enter address</ErrMargin>;
        } else {
          val.address.line1Error = null;
        }
        if (!val.address.zip ) {
          val.address.zipError = <ErrMargin>Please enter zip code</ErrMargin>;
        } else if (val.address.country == "0") {
          if ((val.address.zip.length > 0 && val.address.zip.length < 5) ||
          (val.address.zip.length > 5 && val.address.zip.length < 10 && val.address.zip.indexOf("-") != 5) ||
          (val.address.zip.length > 10) ||
          (val.address.zip.length == 10 && val.address.zip.indexOf("-") != 5)) {
            val.address.zipError = (
              <ErrMargin>
                The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue.
              </ErrMargin>
            );
          } else {
            val.address.zipError = null;
          }
        } else if (val.address.country != "0" && !val.address.zip.length) {
            val.address.zipError = <ErrMargin>Please enter zip code</ErrMargin>;
        } else {
          val.address.zipError = null;
        }

        if (!val.address.city) {
          val.address.cityError = <ErrMargin>Please enter city</ErrMargin>;
        } else if (val.address.city.length < 2) {
          val.address.cityError = <ErrMargin>City name is too short</ErrMargin>;
        } else {
          val.address.cityError = null;
        }
        if (val.address.country == "0") {
          if (!val.address.state) {
            val.address.stateError = <ErrMargin>Please enter state</ErrMargin>;
          } else if (val.address.state.length < 2) {
            val.address.stateError = (
              <ErrMargin>State name is too short</ErrMargin>
            );
          } else {
            val.address.stateError = null;
          }
        }

        if (!val.address.country) {
          val.address.countryError = (
            <ErrMargin>Please specify country</ErrMargin>
          );
        } else {
          val.address.countryError = null;
        }

         let state =val.address.country == "0" ? val.address.state: true;
          if (
            this.props.percentage &&
            val.name &&
            !val.emailError &&
            val.address.line1 &&
            val.address.zip &&
            val.address.city &&
            state &&
            val.address.country &&
            val.charityAllocPercent &&
            val.grantRecognition &&
            val.grantPurpose
          ) {
            hasFieldValues = true;
            if(val.grantPurpose === 'AOMN' || (val.grantPurpose === 'OTHER' && val.otherGrantPurposeText)){
              validationCounter++;
            }
          } else hasFieldValues = false;
        
        if(totalCharityPercentage !== 100){
          val.multipleCharitiesError = (
            <MarginWrapper><ErrMargin>Total percentage should be 100%</ErrMargin></MarginWrapper>
          )
          charityAllocFlag = false;
          accordionState[this.props.contentKey - 1] = 1;
          this.props.getAccordionStatus(true);
        } else {
          charityAllocFlag = true;
          val.multipleCharitiesError = null;
        }
        
        if(validationCounter !== arr.length){
          accordionState[this.props.contentKey - 1] = 1;
          this.props.getAccordionStatus(true);
        }else{
          if(charityAllocFlag){
            accordionState[this.props.contentKey - 1] = 2;
            initiateTracking('buttonStep','Open Additional Account', 'Step 2 Legacy options - '+ this.props.head,'Save to Continue');
            this.props.getAccordionStatus(true);
          }
        }

      } else {
        if (val.relationshipType == "") {
          val.relationshipTypeError = (
            <ErrMargin>Please specify relation</ErrMargin>
          );
        } else {
          val.relationshipTypeError = null;
        }
        if (val.firstName == "") {
          val.firstNameError = <ErrMargin>Please enter first name</ErrMargin>;
        } else if (val.firstName.length < 2) {
          val.firstNameError = <ErrMargin>First name is too short</ErrMargin>;
        } else {
          val.lastNameError = null;
        }
        if (val.lastName == "") {
          val.lastNameError = <ErrMargin>Please enter last name</ErrMargin>;
        } else if (val.lastName.length < 2) {
          val.lastNameError = <ErrMargin>Last name is too short</ErrMargin>;
        } else {
          val.lastNameError = null;
        }

         /**
         * Checking For Primary And Secondary Advisor For Open Additional Account
         */
        if(this.checkForAdvisor(this.props.primaryAdvisor,val) || this.checkForAdvisor(this.props.secondaryAdvisor,val)){
          advTab = 'The succesor advisor ';
          tabIndexError.push((currentIndex + 1));
          advisorMatchCounter += 1;
          val.duplicateError = true;
        }else{
          val.duplicateError = null;
        }

        if (val.dob == "") {
          val.dobError = <ErrMargin>Please enter the date of birth</ErrMargin>;
        } else {
          val.dobError = null;
        }

        if (val.gender == "") {
          val.genderError = <ErrMargin>Please select gender.</ErrMargin>;
        } else {
          val.genderError = null;
        }
        
        let reg = regexMap.emailRegEx;
        if (!reg.test(val.preferedEmail) && val.preferedEmail !== "") {
          val.preferedEmailError = (
            <ErrMargin>
              Email address should follow the format x@x.x
            </ErrMargin>
          );
        } else {
          val.preferedEmailError = null;
        }
        if (!val.address.line1 ) {
          val.address.line1Error = <ErrMargin>Please enter address</ErrMargin>;
        } else {
          val.address.line1Error = null;
        }

        if (!val.address.zip) {
          val.address.zipError = <ErrMargin>Please enter zip code</ErrMargin>;
        } else if (val.address.country == "0" && val.address.zip) {
          if (val.address.zip.length > 0 && val.address.zip.length < 5) {
            val.address.zipError = (
              <ErrMargin>
                The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue.
              </ErrMargin>
            );
          } else if (
            val.address.zip.length > 5 &&
            val.address.zip.length < 10
          ) {
            if (val.address.zip.indexOf("-") != 5) {
              val.address.zipError = (
                <ErrMargin>
                  The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue.
                </ErrMargin>
              );
            }
          } else if (val.address.zip.length > 10) {
            val.address.zipError = (
              <ErrMargin>
                The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue.
              </ErrMargin>
            );
          } else if (val.address.zip.length == 10) {
            if (val.address.zip.indexOf("-") != 5) {
              val.address.zipError = (
                <ErrMargin>
                  The zip code must be in one of the following two formats: xxxxx or xxxxx-xxxx. Please correct to continue.
                </ErrMargin>
              );
            }
          } else {
            val.address.zipError = null;
          }
        } else if (val.address.country != "0" &&  !val.address.zip) {
            val.address.zipError = <ErrMargin>Please enter zip code</ErrMargin>;
        } else {
          val.address.zipError = null;
        }

        if (!val.address.city) {
          val.address.cityError = <ErrMargin>Please enter city</ErrMargin>;
        } else if (val.address.city.length < 2) {
          val.address.cityError = <ErrMargin>City name is too short</ErrMargin>;
        } else {
          val.address.cityError = null;
        }
        if (val.address.country == "0") {
          if (!val.address.state) {
            val.address.stateError = <ErrMargin>Please enter state</ErrMargin>;
          } else if (val.address.state.length < 2) {
            val.address.stateError = (
              <ErrMargin>State name is too short</ErrMargin>
            );
          } else {
            val.address.stateError = null;
          }
        }

        if (val.address.country == "") {
          val.address.countryError = (
            <ErrMargin>Please specify country</ErrMargin>
          );
        } else {
          val.address.countryError = null;
        }
        if (hasFieldValues == true) {
          if (
            percentage != "" &&
            !(
              val.relationshipTypeError ||
              val.firstNameError ||
              val.lastNameError ||
              val.dobError ||
              val.genderError ||
              val.preferedEmailError  ||
              val.address.line1Error ||
              val.address.zipError ||
              val.address.cityError ||
              val.address.stateError ||
              val.address.countryError 
            )
          ) {
            hasFieldValues = true;
            accordionState[this.props.contentKey - 1] = 2;
            initiateTracking('buttonStep','Open Additional Account', 'Step 2 Legacy options - '+ this.props.head,'Save to Continue');
          } else {
            hasFieldValues = false;
            accordionState[this.props.contentKey - 1] = 1;
          }
        }
      }
    });

    if(advisorMatchCounter !== 0){
      accordionState[this.props.contentKey - 1] = 1;
      entireData[this.props.contentKey - 1].duplicateAdvisorError = {
        status: true,
        advTab: advTab,
        index: tabIndexError,
        msg: 'cannot match an existing account advisor. Please select another successor advisor.',
        contentKey: this.props.contentKey 
      };
    }else{
      entireData[this.props.contentKey - 1].duplicateAdvisorError = {
        status: false,
        advTab: null,
        index: [],
        msg: null,
        contentKey: null 
      };

    }
    if (this.props.isStep2Edit) {
      let tempData = this.props.tempData.tempJSON;
      tempData.legacyOptions = entireData;
      this.props.jsonTemp({
        tempJSON: tempData,
        enableReset: true
      });
    } else {
      this.props.setPercentage({
        legacyOptions: {
          legacyOptions: entireData
        }
      });
    }

    await this.props.updateAccordionState(accordionState);

    this.props.setSuccessorValues({
      successorAdvisor: arr,
      key: this.props.contentKey,
      successorKey: this.props.successorKey - 1
    });
      this.props.shouldClose({
        shouldClose: true
      });
      this.props.fieldValues({
        hasfeildvalues: hasFieldValues
      });
      this.props.handleChange();
      this.props.showRemainingPercentage({
        showRemainingPercentage: true,
        key: this.props.contentKey,
        value: true
      });

    this.props.getAccordionStatus(true);
    this.props.updateAccordionStatus(true);
  };

  // Generating Button Name for different tabs - Ex : + Add Successor or + Add Successor Account
  getButtonName = (type) => {
    if(type === 'Appoint up to 2 individuals'){
      return "Successor";
    }else if(type === 'Create accounts'){
      return "Successor Account";
    }else{
      return "Charity";
    }
  }

  handleRemove = () => {
    initiateTracking('remove','Open Additional Account', 'Step 2 Legacy options - ' + this.props.head,'Remove '+ this.getButtonName(this.props.head));
    this.setState({
      show: !this.state.show,
      type: "remove"
    });
    this.props.remove(this.props.successorKey, this.props.contentKey);
  };

  checkFields = successors => {
    let percent;
    if (this.props.isStep2Edit) {
      percent = this.props.tempData.tempJSON.legacyOptions[
        this.props.contentKey - 1
      ].percentage;
    } else {
      percent = this.props.percentage;
    }
    let hasFormValue = false;
    if (percent) {
      hasFormValue = true;
    } else {
      let arr = successors;
      if (arr.length > 1) {
        hasFormValue = true;
      } else {
        arr.forEach(val => {
          let keys = Object.keys(val);
          for (let i in keys) {
            let keyVal = keys[i];
            if (keyVal != "key" && keyVal == "address") {
              let keys = Object.keys(val.address);
              for (let i in keys) {
                let keyVal = keys[i];
                if (
                  keyVal != "country" &&
                  keyVal != "line1Error" &&
                  keyVal != "zipError" &&
                  keyVal != "cityError" &&
                  keyVal != "stateError" &&
                  keyVal != "countryError"
                ) {
                  if (
                    val.address.hasOwnProperty(keyVal) &&
                    val.address[keyVal]
                  ) {
                    hasFormValue = true;
                  }
                }
              }
            } else if (
              keyVal != "charityNameError" &&
              keyVal != "key" &&
              keyVal != "relationshipTypeError" &&
              keyVal != "firstNameError" &&
              keyVal != "lastNameError" &&
              keyVal != "dobError" &&
              keyVal != "genderError" &&
              keyVal != "preferedPhoneError" &&
              keyVal != "preferedEmailError" &&
              keyVal != "phoneError" &&
              keyVal != "emailError"
            ) {
              if (val.hasOwnProperty(keyVal) && val[keyVal]) {
                hasFormValue = true;
              }
            }
          }
        });
      }
    }
    return hasFormValue;
  };

  addSuccessorAccounts() {
    try {
      initiateTracking('buttonStep','Open Additional Account', 'Step 2 Legacy options - ' + this.props.head,'Add '+ this.getButtonName(this.props.head));
      this.props.add(this.props.contentKey);
    } catch (error) {
      recordError(error);
    }
  }
  removeSuccessorAccount() {
    this.setState({
      show: !this.state.show,
      type: "remove"
    });
  }

  filterDropDownDataWithValue(value, dropdown, field) {
    if (value != "" && dropdown && dropdown.length != 0) {
      let desc = dropdown.filter(val => {
        return val.desc == value;
      });
      if (desc != undefined) {
        return desc[0];
      } else {
        return null;
      }
    }
  }

  componentWillReceiveProps(nextprops){
    if(!_.isEmpty(nextprops.zipCodeData)){
      let successors = [];
      if (this.props.isStep2Edit) {
        if (this.props.contentKey == 1 || this.props.contentKey == 2) {
          successors = this.props.tempData.tempJSON.legacyOptions[
            this.props.contentKey - 1
          ].successorAdvisor;
        } else {
          successors = this.props.tempData.tempJSON.legacyOptions[
            this.props.contentKey - 1
          ].successionPlanGranteeOrg;
        }
      } else {
        successors = this.props.legacy.legacyOptions[this.props.contentKey - 1]
          .successorAdvisor.successorAdvisor;
      }

      let flag = false;
      if(this.props.editCity){
        successors.length && successors.forEach((data,i) => {
          if(data.key == this.props.successorKey){
            let addr = data.address;
            if(addr.zipTitle && nextprops.zipCodeData[addr.zipTitle] && !nextprops.zipCodeData[addr.zipTitle].loading){
              if(nextprops.zipCodeData[addr.zipTitle].city){
                addr.city = nextprops.zipCodeData[addr.zipTitle].city;
                let stateObj = this.filterDropDownDataWithValue(nextprops.zipCodeData[addr.zipTitle].state,nextprops.dropDown.states);
                addr.state = (stateObj && stateObj.value) ? stateObj.value : undefined;
                addr.cityError = null;
                addr.stateError = null;
              }else{
                addr.city= null;
                addr.state= null;
              }
              flag = true;
            }
          }
        })
  
      }
      
      if(flag){
        this.props.setCityFieldEdit(false);
        this.props.setSuccessorValues({
          successorAdvisor: successors,
          key: this.props.contentKey,
          successorKey: this.props.successorKey - 1
        });
      }
      
    }
  }

  render() {
    const { alertOOA } = this.props;
    const { alertStatus, removePopupContentAppoint, removePopupContentCreate, removePopupContentCharity } = this.state;
    
    if(alertOOA && alertOOA.length && !alertStatus){
      this.setState({
        removePopupContentAppoint: mapContents(getAlert(alertOOA,'Remove successor'), removePopupContentAppoint),
        removePopupContentCreate: mapContents(getAlert(alertOOA,'Remove successor account'), removePopupContentCreate),
        removePopupContentCharity: mapContents(getAlert(alertOOA,'Remove charity'), removePopupContentCharity),
        alertStatus: true
      })
    }

    let successors;
    if (this.props.isStep2Edit) {
      if (this.props.contentKey == 1 || this.props.contentKey == 2) {
        successors = this.props.tempData.tempJSON.legacyOptions[
          this.props.contentKey - 1
        ].successorAdvisor;
      } else {
        successors = this.props.tempData.tempJSON.legacyOptions[
          this.props.contentKey - 1
        ].successionPlanGranteeOrg;
      }
    } else {
      successors = this.props.legacy.legacyOptions[this.props.contentKey - 1]
        .successorAdvisor.successorAdvisor;
    }

    let entireData = null;
    if (this.props.isStep2Edit) {
      entireData = this.props.tempData.tempJSON.legacyOptions;
    } else {
      entireData = this.props.legacy.legacyOptions;
    }
    return (
      <div>
        {this.state.show === true ? (
          <Popup
            height="313px"
            width="481px"
            mwidth="88%"
            mheight="53%"
            content={
              this.props.contentKey == 1
                ? removePopupContentAppoint
                : this.props.contentKey == 2
                ? removePopupContentCreate
                : removePopupContentCharity
            }
            closeModal={this.closeModal}
            handleRemove={this.handleRemove}
          />
        ) : null}
        {this.props.contentKey == 4 ? (
          <CharityBasicInfo
            successorKey={this.props.successorKey}
            contentKey={this.props.contentKey}
          />
        ) : (
          <div>
            <SuccessorInfo
              successorKey={this.props.successorKey}
              contentKey={this.props.contentKey}
            />
            <PhoneInfo
              successorKey={this.props.successorKey}
              contentKey={this.props.contentKey}
            />
            <EmailInfo
              successorKey={this.props.successorKey}
              contentKey={this.props.contentKey}
            />
          </div>
        )}

        <AddressInfo
          successorKey={this.props.successorKey}
          contentKey={this.props.contentKey}
          zipCodeData={this.props.zipCodeData}
          resetZipCode={(val, field)=>this.props.resetZipCode(val, field)}
          resetAllZipCode={(val) => this.props.resetAllZipCode(val)}
        />
        {this.props.contentKey == 1 ? (
          this.props.count <= 1 ? (
            <MarginWrapperBtn>
              <CapsuleButton 
                text = "Add Successor"
                iconType = "add"
                onClick={this.addSuccessorAccounts.bind(this)}
              />
            </MarginWrapperBtn>
          ) : (
            <>
              {this.props.successorKey == 2 && (
                <MarginWrapperBtn>
                  <CapsuleButton
                    text = "Remove Successor -"
                    onClick={this.removeSuccessorAccount.bind(this)}
                  />
                </MarginWrapperBtn>
              )}
            </>
          )
        ) : this.props.contentKey == 4 ? (
          this.props.charityCount < 20 && this.props.charityCount > 1 ? (
            <div>
              <PillButtonAddSpaceAdd>
                <MarginWrapperBtn>
                  <CapsuleButton
                    text = "Remove Charity -"
                    onClick={this.removeSuccessorAccount.bind(this)}
                  />
                </MarginWrapperBtn>
              </PillButtonAddSpaceAdd>

              <MarginWrapperBtn>
                <CapsuleButton
                  text = "Add Charity"
                  iconType = "add"
                  onClick={this.addSuccessorAccounts.bind(this)}
                />
              </MarginWrapperBtn>
            </div>
          ) : this.props.charityCount == 20 ? (
            <>
              <PillButtonAddSpaceAddManual>
                <ErrMargin>
                  Please contact VC to add additional organisations to your plan
                </ErrMargin>
              </PillButtonAddSpaceAddManual>
              
              <MarginWrapperBtn>
                <CapsuleButton
                  text = "Remove Charity -"
                  onClick={this.removeSuccessorAccount.bind(this)}
                />
              </MarginWrapperBtn>
            </>
          ) : (
            <MarginWrapperBtn>
              <CapsuleButton
                text = "Add Charity"
                iconType = "add"
                onClick={this.addSuccessorAccounts.bind(this)}
              />
            </MarginWrapperBtn>
          )
        ) : this.props.createCount < 6 && this.props.createCount > 1 ? (
          <div>
            <PillButtonAddSpaceAdd>
              <MarginWrapperBtn>
                <CapsuleButton
                  text = "Remove Successor Account -"
                  onClick={this.removeSuccessorAccount.bind(this)}
                />
              </MarginWrapperBtn>
            </PillButtonAddSpaceAdd>
            <MarginWrapperBtn>
              <CapsuleButton
                text = "Add Successor Account"
                iconType = "add"
                onClick={this.addSuccessorAccounts.bind(this)}
              />
            </MarginWrapperBtn>

          </div>
        ) : this.props.createCount == 6 ? (
          <CapsuleButton
            text = "Remove Successor Account -"
            onClick={this.removeSuccessorAccount.bind(this)}
          />
        ) : (
          <MarginWrapperBtn>
            <CapsuleButton
              text = "Add Successor Account"
              iconType = "add"
              onClick={this.addSuccessorAccounts.bind(this)}
            />
          </MarginWrapperBtn>
        )}

         {entireData[this.props.contentKey - 1].duplicateAdvisorError && 
          entireData[this.props.contentKey - 1].duplicateAdvisorError.status && 
          entireData[this.props.contentKey - 1].duplicateAdvisorError.contentKey == this.props.contentKey && (
            <ErrMargin style={{marginTop:'0px'}}>
              {entireData[this.props.contentKey - 1].duplicateAdvisorError.advTab}{' '}
              {entireData[this.props.contentKey - 1].duplicateAdvisorError.index && 
              entireData[this.props.contentKey - 1].duplicateAdvisorError.index.join(',')}{' '}
              {entireData[this.props.contentKey - 1].duplicateAdvisorError.msg}
            </ErrMargin>
         )}

        {this.checkFields(successors) ? (
          <PillButtonGreenWrap>
            <PillButtonGreen onClick={() => this.handleSave(successors)}>
              Save to Continue
            </PillButtonGreen>
          </PillButtonGreenWrap>
        ) : (
          <ShowLessWrapMargin>
            <CapsuleButton 
              text = 'Show Less'
              onClick = {this.props.handleChange}
              whiteBackground = {true}
              iconType = "arrowUp"
            />
          </ShowLessWrapMargin>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  validationCheck: state.getIn(["npaFormReducer", "validationCheck"]),
  count: state.getIn(["npaFormReducer", "advisorCount", "count"]),
  successorTab: state.getIn(["successorTab"]),
  createCount: state.getIn(["npaFormReducer", "advisorCount", "createCount"]),
  charityCount: state.getIn(["npaFormReducer", "advisorCount", "charityCount"]),
  percentage: state.getIn([
    "npaFormReducer",
    "legacyOptions",
    "legacyOptions",
    "legacyOptions",
    `${ownProps.contentKey - 1}`,
    "percentage"
  ]),
  legacy: state.getIn(["npaFormReducer", "legacyOptions", "legacyOptions"]),
  isStep2Edit: state.getIn([
    "npaFormReducer",
    "isStep2Edit",
    "isStep2Edit",
    "isStep2Edit"
  ]),
  tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON"]),
  accordionStates: state.getIn(["npaFormReducer","accordionStates"]),
  alertOOA: state.getIn(['npaFormReducer','alerts']),
  zipCodeData: state.getIn(['zipCode', 'zipCodes']).toJS(),
  dropDown: state.getIn(["npaFormReducer", "dropdownValues", "data"]),
  editCity: state.getIn(["npaFormReducer", "editCity"]),
  primaryAdvisor: state.getIn(["npaFormReducer", "primaryAdvisor", "info"]),
  secondaryAdvisor: state.getIn(["npaFormReducer", "secondaryAdvisor", "info"]),
});

export const mapDispatchToProps = dispatch => ({
  showRemainingPercentage: val => dispatch(showRemainingPercentage(val)),
  setSuccessorValues: val => dispatch(setSuccessorValues(val)),
  shouldClose: val => dispatch(shouldClose(val)),
  setPercentage: val => dispatch(setPercentage(val)),
  jsonTemp: val => dispatch(jsonTemp(val)),
  fieldValues: val => dispatch(fieldValues(val)),
  validationHandler: val => dispatch(validationHandler(val)),
  getAccordionStatus: val => dispatch(getAccordionStatus(val)),
  updateAccordionStatus: data => dispatch(updateAccordionStatus(data)),
  updateAccordionState: data => dispatch(updateAccordionState(data)),
  resetZipCode: (val, field) => dispatch(resetZipCode(val, field)),
  resetAllZipCode: (val) => dispatch(resetAllZipFields(val)),
  setCityFieldEdit: val => dispatch(setCityFieldEdit(val))
});

Form.propTypes = {
  accordionStates: PropTypes.any,
  add: PropTypes.func,
  alertOOA: basicAlertContents,
  charityCount: PropTypes.number,
  contentKey: PropTypes.number,
  count: PropTypes.number,
  createCount: PropTypes.number,
  dropDown: PropTypes.object,
  editCity: PropTypes.bool,
  fieldValues: PropTypes.func,
  getAccordionStatus: PropTypes.func,
  handleChange: PropTypes.func,
  head: PropTypes.string,
  isStep2Edit: PropTypes.any,
  jsonTemp: PropTypes.func,
  legacy: PropTypes.object,
  percentage: PropTypes.string,
  primaryAdvisor: PropTypes.object,
  remove: PropTypes.func,
  resetAllZipCode: PropTypes.func,
  resetZipCode: PropTypes.func,
  secondaryAdvisor:  PropTypes.object,
  setCityFieldEdit: PropTypes.func,
  setPercentage: PropTypes.func,
  setSuccessorValues: PropTypes.func,
  shouldClose: PropTypes.func,
  showRemainingPercentage: PropTypes.func,
  successorKey: PropTypes.string,
  successorTab: PropTypes.any,
  tempData: PropTypes.any,
  updateAccordionState: PropTypes.func,
  updateAccordionStatus: PropTypes.func,
  validationCheck: PropTypes.bool,
  validationHandler: PropTypes.func,
  zipCodeData: PropTypes.object,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form);